import pkg from "../package.json";

console.log(`Backoffice WebApp v${pkg.version}`);
